export default "__VITE_ASSET__DNp5H297c$xV42a1l6t5aA__"